import { render, staticRenderFns } from "./ProjectCommentTab.vue?vue&type=template&id=6107caea&scoped=true&"
import script from "./ProjectCommentTab.vue?vue&type=script&lang=ts&"
export * from "./ProjectCommentTab.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectCommentTab.vue?vue&type=style&index=0&id=6107caea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6107caea",
  null
  
)

export default component.exports